import { NavLink } from 'modules/layout/components/PrivateNavBar';
import { PathsV2 } from 'core/services/navigation/pathsV2';

export const hideLinksWhenInternalSourcingAreNotEnabled = (
  links: NavLink[],
  internalSourcingEnabled: boolean
) => {
  if (internalSourcingEnabled) {
    return links;
  }

  return links.filter(
    (link) => !link.to.includes(PathsV2.CANDIDATE_PROFILE_LIST)
  );
};
